import { withToman } from '@rahtab/system/lib/tools/string';
import { Card, CardCaption, CardContainer, getSpacing, Rating, Tag, Text } from '@rahtab/ui';
import React, { VFC } from 'react';
import { StyleSheet, View } from 'react-native';
import moment from 'moment-jalaali';

const LoadDetail: VFC<LoadDetailProps> = ({
  loadOrderLimit,
  date,
  time,
  numberOfRates,
  productName,
  rate,
  unitPrice,
  productCode,
  measureUnit,
  termName,
}) => {
  return (
    <Card style={styles.container}>
      <CardContainer>
        <View style={styles.nameCodeView}>
          <Text margin="none" color="primary" variant="title">
            {productName}
          </Text>
          <Tag text="کد کالا: " margin="none">
            <Text color="primary" variant="subtitle" margin="none">
              {productCode}
            </Text>
          </Tag>
        </View>
        {!!termName ? (
          <Text color="description">
            دوره:طرح
            <Text>
              {' '}
              <Text> {termName}</Text>
            </Text>
          </Text>
        ) : (
          <Text color="description">
            تاریخ تحویل:
            <Text>
              {' '}
              {moment(date).format('jYYYY/jMM/jDD')}
              <Text> {time}</Text>
            </Text>
          </Text>
        )}
        <Text color="description">
          قیمت واحد:
          <Text> {withToman(unitPrice)}</Text>
        </Text>
        <View style={styles.rateContainer}>
          <Text margin="none" color="description">
            رضایت‌مندی از کالا:
          </Text>
          <Rating style={styles.rate} count={numberOfRates} value={rate} />
        </View>
      </CardContainer>
      <CardCaption color="primary" style={styles.caption}>
        <Text color="white" margin="none">
          حداکثر مقدار قابل سفارش‌گذاری:
        </Text>
        <Text color="white" margin="none">
          {loadOrderLimit} {measureUnit}
        </Text>
      </CardCaption>
    </Card>
  );
};

export default LoadDetail;

const styles = StyleSheet.create({
  container: {
    marginVertical: getSpacing(),
  },
  nameCodeView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: getSpacing(0.5),
  },
  caption: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rateContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rate: {
    marginLeft: getSpacing(0.5),
  },
});

interface LoadDetailProps {
  productCode: string;
  loadOrderLimit?: string;
  productName?: string;
  date?: Date;
  time?: string;
  unitPrice?: number;
  rate: number;
  numberOfRates: number;
  measureUnit: string;
  termName?: string;
}
